<template>
    <div id="edit_driver_commission_policy">
        <h1 class="ui header">收派件提成政策</h1>
        <div v-if="is_initialized">
            <form class="ui form">
                <div class="field">
                    <div class="ui slider checkbox">
                        <input type="checkbox" id="is_activated"
                            v-model="driver_commission_policy.is_activated"
                        >
                        <label for="is_activated">
                            啟用
                        </label>
                    </div>
                </div>
                <h3 class="ui header">一般件</h3>
                <div class="field">
                    <label>取件首重重量(KG)</label>
                    <input type="number" v-model="driver_commission_policy.pick_up_first_weight">
                </div>
                <div class="field">
                    <label>取件首重提成金額</label>
                    <input type="number" v-model="driver_commission_policy.pick_up_first_price">
                </div>
                <div class="field">
                    <label>取件續重重量單位(KG)</label>
                    <input type="number" v-model="driver_commission_policy.pick_up_follow_up_weight">
                </div>
                <div class="field">
                    <label>取件續重單價</label>
                    <input type="number" v-model="driver_commission_policy.pick_up_follow_up_price">
                </div>
                <div class="field">
                    <label>送件首重重量(KG)</label>
                    <input type="number" v-model="driver_commission_policy.delivery_first_weight">
                </div>
                <div class="field">
                    <label>送件首重提成金額</label>
                    <input type="number" v-model="driver_commission_policy.delivery_first_price">
                </div>
                <div class="field">
                    <label>送件續重重量單位(KG)</label>
                    <input type="number" v-model="driver_commission_policy.delivery_follow_up_weight">
                </div>
                <div class="field">
                    <label>送件續重單價</label>
                    <input type="number" v-model="driver_commission_policy.delivery_follow_up_price">
                </div>
                <div class="ui divider"></div>
                <h3 class="ui header">袋裝</h3>
                <div class="field">
                    <label>取件首重重量(KG)</label>
                    <input type="number" v-model="driver_commission_policy.house_pick_up_first_weight">
                </div>
                <div class="field">
                    <label>取件首重提成金額</label>
                    <input type="number" v-model="driver_commission_policy.house_pick_up_first_price">
                </div>
                <div class="field">
                    <label>取件續重重量單位(KG)</label>
                    <input type="number" v-model="driver_commission_policy.house_pick_up_follow_up_weight">
                </div>
                <div class="field">
                    <label>取件續重單價</label>
                    <input type="number" v-model="driver_commission_policy.house_pick_up_follow_up_price">
                </div>
                <div class="field">
                    <label>送件首重重量(KG)</label>
                    <input type="number" v-model="driver_commission_policy.house_delivery_first_weight">
                </div>
                <div class="field">
                    <label>送件首重提成金額</label>
                    <input type="number" v-model="driver_commission_policy.house_delivery_first_price">
                </div>
                <div class="field">
                    <label>送件續重重量單位(KG)</label>
                    <input type="number" v-model="driver_commission_policy.house_delivery_follow_up_weight">
                </div>
                <div class="field">
                    <label>送件續重單價</label>
                    <input type="number" v-model="driver_commission_policy.house_delivery_follow_up_price">
                </div>

                <button class="ui basic positive button" @click.prevent="update">{{ $t('ui.general.update') }}</button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "EditDriverCommissionPolicy",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            driver_commission_policy: {},
            errors: [],
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "edit_driver_commission_policy") {
                this.init()
            }
        },
    },
    computed: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_processing = false
                this.driver_commission_policy = {}
                this.errors = []
                resolve()
            })
            await this.fetch_driver_commission_policy()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        fetch_driver_commission_policy() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_driver_commission_policy).parse(
                {
                    "driver_commission_policy_identity": this.$route.params.identity
                },
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    this.driver_commission_policy = response.data.driver_commission_policy
                    return Promise.resolve()
                })
                .catch(error => {
                    console.log('Failed to fetch driver_commission_policy.')
                })
        },
        update() {
            this.is_processing = true
            this.errors = []
            // Prepare parameters
            var params = this.driver_commission_policy
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_driver_commission_policy_update).parse(
                {
                    "driver_commission_policy_identity": this.$route.params.identity,
                },
                ""
            )

            axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                if (response.data.status == "success") {
                    // this.$noty.success("收派件提成政策更新成功")
                    this.$noty.success(
                        this.$t('ui.notifications.success.update__name', {
                            name: this.$t('models.driver_commission_policies')
                        })
                    )
                    this.$router.push('/provider/driver_commission_policies')
                } else {
                    // this.$noty.error("收派件提成政策更新失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.update__name', {
                            name: this.$t('models.driver_commission_policies'),
                            reason: ': ' + response.data.errors
                        })
                    )
                    this.errors = response.data.errors
                }
            })
            .catch(error => {
                console.log(error)
                if (!error.response) {
                    // Network Error
                    this.$noty.error(
                        this.$t('ui.general.network_abnormality')+": "+
                        this.$t('ui.general.server_offline')
                    )
                } else {
                    this.$noty.error(this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data)
                }
            })
            this.is_processing = false
        },
    },
    components: {
    }
}
</script>

<style scoped>
</style>
